const baseSrc = '//res.cloudinary.com/danrx4fes/image/upload/'

export type ProjectImageType = {
  src: string
  h: number
  w: number,
}

export type ProjectType = {
  name: string
  year: number
  src: string
  className: string
  category: string
  priority: number
  images: ProjectImageType[],
}

export const projectsById: { [key: string]: ProjectType } = {
  'crj-cco': {
    name: 'Carajás',
    year: 2007,
    src: baseSrc + 'c_fill,h_200,w_200/PROJETOS/CCO/2007/CC_2007_1crj',
    className: 'proj-cco',
    category: 'Centro de Controle Operacional',
    priority: 1.3,
    images: [
      {
        src: baseSrc + 'PROJETOS/CCO/2007/CC_2007_1crj',
        w: 1600,
        h: 1200,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2007/CC_2007_2crj',
        w: 800,
        h: 600,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2007/CC_2007_3crj',
        w: 1431,
        h: 1034,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2007/CC_2007_4crj',
        w: 2592,
        h: 1944,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2007/CC_2007_5crj',
        w: 1844,
        h: 1332,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2007/CC_2007_6crj',
        w: 1536,
        h: 2048,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2007/CC_2007_7crj',
        w: 1386,
        h: 1001,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2007/CC_2007_8crj',
        w: 1424,
        h: 1029,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2007/CC_2007_9crj',
        w: 1415,
        h: 1022,
      },
    ],
  },
  'tub-cco': {
    name: 'Tubarão',
    year: 2008,
    src: baseSrc + 'c_fill,h_200,w_200/PROJETOS/CCO/2008/TUBARAO/CC_2008_1vix',
    className: 'proj-cco',
    category: 'Centro de Controle Operacional',
    priority: 3,
    images: [
      {
        src: baseSrc + 'PROJETOS/CCO/2008/TUBARAO/CC_2008_1vix',
        w: 1358,
        h: 1305,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2008/TUBARAO/2vix',
        w: 2084,
        h: 1792,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2008/TUBARAO/3vix',
        w: 2048,
        h: 1383,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2008/TUBARAO/4vix',
        w: 2048,
        h: 1029,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2008/TUBARAO/5vix',
        w: 2048,
        h: 1257,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2008/TUBARAO/6vix',
        w: 2048,
        h: 1536,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2008/TUBARAO/7vix',
        w: 2000,
        h: 1498,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2008/TUBARAO/8vix',
        w: 2000,
        h: 879,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2008/TUBARAO/9vix',
        w: 2000,
        h: 725,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2008/TUBARAO/10vix',
        w: 4015,
        h: 2535,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2008/TUBARAO/11vix.jpg',
        w: 1169,
        h: 826,
      },
    ],
  },
  'mtr-cco': {
    name: 'Metrô Rio',
    year: 2009,
    src: baseSrc + 'c_fill,h_200,w_200/PROJETOS/CCO/2009/1mtr_cco',
    className: 'proj-cco',
    category: 'Centro de Controle Operacional',
    priority: 1.2,
    images: [
      {
        src: baseSrc + 'PROJETOS/CCO/2009/1mtr_cco',
        w: 3413,
        h: 2267,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2009/2mtr_cco',
        w: 3413,
        h: 2267,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2009/3mtr_cco',
        w: 1883,
        h: 1360,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2009/4mtr_cco',
        w: 1535,
        h: 1020,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2009/5mtr_cco',
        w: 1772,
        h: 1178,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2009/7mtr_cco',
        w: 2048,
        h: 1360,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2009/8mtr_cco',
        w: 1360,
        h: 2048,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2009/9mtr_cco',
        w: 1772,
        h: 1271,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2009/10mtr_cco',
        w: 2048,
        h: 1360,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2009/11mtr_cco',
        w: 2048,
        h: 1360,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2009/12mtr_cco',
        w: 5691,
        h: 1864,
      },
    ],
  },
  'spv-cco': {
    name: 'Supervia',
    year: 2012,
    src: baseSrc + 'c_fill,h_200,w_200/PROJETOS/CCO/2012/1spv',
    className: 'proj-cco',
    category: 'Centro de Controle Operacional',
    priority: 1,
    images: [
      {
        src: baseSrc + 'PROJETOS/CCO/2012/1spv',
        w: 5054,
        h: 3370,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2012/2spv',
        w: 5054,
        h: 3370,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2012/3spv',
        w: 5054,
        h: 3370,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2012/4spv',
        w: 4928,
        h: 3264,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2012/5spv',
        w: 5054,
        h: 3370,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2012/6spv',
        w: 5054,
        h: 3370,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2012/7spv',
        w: 5054,
        h: 3370,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2012/8spv',
        w: 4549,
        h: 3033,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2012/9spv',
        w: 3370,
        h: 5054,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2012/10spv',
        w: 4928,
        h: 3264,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2012/11spv',
        w: 5054,
        h: 3370,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2012/12spv',
        w: 5054,
        h: 3370,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2012/13spv',
        w: 4928,
        h: 3264,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2012/14spv',
        w: 4328,
        h: 3264,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2012/15spv',
        w: 5054,
        h: 3370,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2012/16spv',
        w: 4928,
        h: 3264,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2012/18spv',
        w: 4057,
        h: 2057,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2012/19spv',
        w: 1600,
        h: 1280,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2012/20spv',
        w: 1600,
        h: 1280,
      },
    ],
  },
  'btg-cco': {
    name: 'BTG Pactual',
    year: 2013,
    src: baseSrc + 'c_fill,h_200,w_200/CCO/2013/BTG/1btg_jsybki',
    className: 'proj-cco',
    category: 'Centro de Controle Operacional',
    priority: 2.1,
    images: [
      {
        src: baseSrc + 'CCO/2013/BTG/1btg_jsybki',
        w: 1428,
        h: 928,
      },
      {
        src: baseSrc + 'CCO/2013/BTG/2btg_jdxrab',
        w: 1428,
        h: 928,
      },
      {
        src: baseSrc + 'CCO/2013/BTG/3btg_dawv2q',
        w: 1428,
        h: 928,
      },
      {
        src: baseSrc + 'CCO/2013/BTG/4btg_qg0rki',
        w: 1014,
        h: 928,
      },
      {
        src: baseSrc + 'CCO/2013/BTG/5btg_sqzbhz',
        w: 2560,
        h: 1920,
      },
      {
        src: baseSrc + 'CCO/2013/BTG/6btg_tginwn',
        w: 2560,
        h: 1920,
      },
      {
        src: baseSrc + 'CCO/2013/BTG/7btg_qkq3ab',
        w: 2560,
        h: 1920,
      },
      {
        src: baseSrc + 'CCO/2013/BTG/8btg_vh1ewn',
        w: 1920,
        h: 2560,
      },
      {
        src: baseSrc + 'CCO/2013/BTG/9btg_eh3fiz',
        w: 2560,
        h: 1920,
      },
    ],
  },
  'epv-cco': {
    name: 'PONTA DA MADEIRA',
    year: 2013,
    src: baseSrc + 'c_fill,h_200,w_200/PROJETOS/CCO/2013/VALE_MA/1vale_epc',
    className: 'proj-cco',
    category: 'Centro de Controle Operacional',
    priority: 2.2,
    images: [
      {
        src: baseSrc + 'PROJETOS/CCO/2013/VALE_MA/1vale_epc',
        w: 1850,
        h: 1050,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2013/VALE_MA/2vale_epc',
        w: 1850,
        h: 1050,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2013/VALE_MA/3vale_epc',
        w: 1850,
        h: 1050,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2013/VALE_MA/4vale_epc',
        w: 1850,
        h: 1050,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2013/VALE_MA/5vale_epc',
        w: 1850,
        h: 1050,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2013/VALE_MA/6vale_epc',
        w: 1850,
        h: 1050,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2013/VALE_MA/7vale_epc',
        w: 3408,
        h: 2381,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2013/VALE_MA/8vale_epc',
        w: 1600,
        h: 1280,
      },
    ],
  },
  'lms-cco': {
    name: 'LAMSA',
    year: 2014,
    src: baseSrc + 'c_fill,h_200,w_200/PROJETOS/CCO/2014/LAMSA/1lms_cco',
    className: 'proj-cco',
    category: 'Centro de Controle Operacional',
    priority: 1.4,
    images: [
      {
        src: baseSrc + 'PROJETOS/CCO/2014/LAMSA/1lms_cco',
        w: 3264,
        h: 2448,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2014/LAMSA/2lms_cco',
        w: 3264,
        h: 2448,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2014/LAMSA/3lms_cco',
        w: 1844,
        h: 1332,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2014/LAMSA/4lms_cco',
        w: 1841,
        h: 1330,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2014/LAMSA/5lms_cco',
        w: 1834,
        h: 1325,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2014/LAMSA/6lms_cco',
        w: 1879,
        h: 1357,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2014/LAMSA/7lms_cco',
        w: 1843,
        h: 1331,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2014/LAMSA/4lms_cco',
        w: 1331,
        h: 1843,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2014/LAMSA/9lms_cco',
        w: 935,
        h: 1294,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2014/LAMSA/10lms_cco',
        w: 1317,
        h: 1823,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2014/LAMSA/11lms_cco',
        w: 1331,
        h: 1843,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2014/LAMSA/12lms_cco',
        w: 1632,
        h: 1224,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2014/LAMSA/13lms_cco',
        w: 1632,
        h: 1224,
      },
    ],
  },
  'pms-cco': {
    name: 'PREFEITURA DE SANTOS',
    year: 2014,
    src: baseSrc + 'c_fill,h_200,w_200/PROJETOS/CCO/2014/PMS/1pms',
    className: 'proj-cco',
    category: 'Centro de Controle Operacional',
    priority: 1.5,
    images: [
      {
        src: baseSrc + 'PROJETOS/CCO/2014/PMS/1pms',
        w: 1860,
        h: 1060,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2014/PMS/2pms',
        w: 1860,
        h: 1060,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2014/PMS/3pms',
        w: 1860,
        h: 1060,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2014/PMS/4pms',
        w: 5752,
        h: 4066,
      },
    ],
  },
  'alu-cco': {
    name: 'ALUNORTE',
    year: 2006,
    src: baseSrc + 'c_fill,h_200,w_200/PROJETOS/CCO/2006/ALUNORTE/1',
    className: 'proj-cco',
    category: 'Centro de Controle Operacional',
    priority: 2.3,
    images: [
      {
        src: baseSrc + 'PROJETOS/CCO/2006/ALUNORTE/1',
        w: 2288,
        h: 1712,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2006/ALUNORTE/2',
        w: 2048,
        h: 1536,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2006/ALUNORTE/2_1',
        w: 2048,
        h: 1536,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2006/ALUNORTE/3',
        w: 2288,
        h: 1712,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2006/ALUNORTE/4',
        w: 1536,
        h: 2048,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2006/ALUNORTE/5',
        w: 1712,
        h: 2288,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2006/ALUNORTE/6',
        w: 2048,
        h: 1536,
      },
    ],
  },
  'corn-cco': {
    name: 'CORN',
    year: 2008,
    src: baseSrc + 'c_fill,h_200,w_200/PROJETOS/CCO/2008/CORN_PRODUCTS/corn1',
    className: 'proj-cco',
    category: 'Centro de Controle Operacional',
    priority: 3.2,
    images: [
      {
        src: baseSrc + 'PROJETOS/CCO/2008/CORN_PRODUCTS/corn1',
        w: 1751,
        h: 1265,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2008/CORN_PRODUCTS/corn2',
        w: 1759,
        h: 1271,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2008/CORN_PRODUCTS/corn3',
        w: 1232,
        h: 924,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2008/CORN_PRODUCTS/corn4',
        w: 1026,
        h: 777,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2008/CORN_PRODUCTS/corn5',
        w: 1232,
        h: 924,
      },
      {
        src: baseSrc + 'PROJETOS/CCO/2008/CORN_PRODUCTS/corn6',
        w: 1231,
        h: 923,
      },
    ],
  },
  'crj-corp': {
    name: 'Carajás',
    year: 2007,
    src:
      baseSrc +
      'c_fill,h_200,w_200/PROJETOS/CORPORATIVO/2007/VALE_CARAJAS/1crj_cor',
    className: 'proj-corp',
    category: 'Corporativo',
    priority: 2.6,
    images: [
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2007/VALE_CARAJAS/1crj_cor',
        w: 1598,
        h: 1154,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2007/VALE_CARAJAS/2crj_cor',
        w: 1042,
        h: 1443,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2007/VALE_CARAJAS/3crj_cor',
        w: 2048,
        h: 1536,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2007/VALE_CARAJAS/4crj_cor',
        w: 2048,
        h: 1536,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2007/VALE_CARAJAS/5crj_cor',
        w: 2048,
        h: 1536,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2007/VALE_CARAJAS/6crj_cor',
        w: 1502,
        h: 1127,
      },
    ],
  },
  'dial-cco': {
    name: 'Dial',
    year: 2007,
    src:
      baseSrc + 'c_fill,h_200,w_200/PROJETOS/CORPORATIVO/2007/VALE_DIAL/1dial',
    className: 'proj-corp',
    category: 'Corporativo',
    priority: 2.7,
    images: [
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2007/VALE_DIAL/1dial',
        w: 2048,
        h: 1360,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2007/VALE_DIAL/2dial',
        w: 2048,
        h: 1536,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2007/VALE_DIAL/3dial',
        w: 1360,
        h: 2048,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2007/VALE_DIAL/4dial',
        w: 1566,
        h: 1131,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2007/VALE_DIAL/5dial',
        w: 2048,
        h: 1536,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2007/VALE_DIAL/6dial',
        w: 2048,
        h: 1536,
      },
    ],
  },
  'mtr-corp': {
    name: 'Metrô Rio',
    year: 2009,
    src: baseSrc + 'c_fill,h_200,w_200/PROJETOS/CORPORATIVO/2009/1mtr_corp',
    className: 'proj-corp',
    category: 'Corporativo',
    priority: 2.5,
    images: [
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2009/1mtr_corp',
        w: 1359,
        h: 1768,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2009/2mtr_corp',
        w: 900,
        h: 598,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2009/3mtr_corp',
        w: 2048,
        h: 1360,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2009/4mtr_corp',
        w: 2560,
        h: 1849,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2009/5mtr_corp',
        w: 2560,
        h: 1920,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2009/6mtr_corp',
        w: 900,
        h: 598,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2009/7mtr_corp',
        w: 900,
        h: 598,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2009/8mtr_corp',
        w: 2048,
        h: 1536,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2009/9mtr_corp',
        w: 828,
        h: 598,
      },
    ],
  },
  'perf-corp': {
    name: 'Performance',
    year: 2012,
    src:
      baseSrc +
      'c_fill,h_200,w_200/PROJETOS/CORPORATIVO/2012/PERFORMANCE/1perf',
    className: 'proj-corp',
    category: 'Corporativo',
    priority: 3.3,
    images: [
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2012/PERFORMANCE/1perf',
        w: 2560,
        h: 1920,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2012/PERFORMANCE/2perf',
        w: 1920,
        h: 2560,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2012/PERFORMANCE/3perf',
        w: 2560,
        h: 1920,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2012/PERFORMANCE/4perf',
        w: 2560,
        h: 1920,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2012/PERFORMANCE/5perf',
        w: 2560,
        h: 1920,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2012/PERFORMANCE/6perf',
        w: 2560,
        h: 1920,
      },
    ],
  },
  'spv-corp': {
    name: 'Supervia',
    year: 2012,
    src:
      baseSrc +
      'c_fill,h_200,w_200/PROJETOS/CORPORATIVO/2012/SUPERVIA/1spv_corp',
    className: 'proj-corp',
    category: 'Corporativo',
    priority: 2.4,
    images: [
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2012/SUPERVIA/1spv_corp',
        w: 2560,
        h: 1920,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2012/SUPERVIA/2spv_corp',
        w: 2560,
        h: 1920,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2012/SUPERVIA/3spv_corp',
        w: 4928,
        h: 3264,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2012/SUPERVIA/4spv_corp',
        w: 4928,
        h: 3264,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2012/SUPERVIA/5spv_corp',
        w: 5054,
        h: 3370,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2012/SUPERVIA/6spv_corp',
        w: 5054,
        h: 3370,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2012/SUPERVIA/7spv_corp',
        w: 3264,
        h: 4928,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2012/SUPERVIA/8spv_corp',
        w: 3370,
        h: 5054,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2012/SUPERVIA/9spv_corp',
        w: 3264,
        h: 4928,
      },
    ],
  },
  'mtd-corp': {
    name: 'Diretoria Metrô Rio',
    year: 2013,
    src: baseSrc + 'c_fill,h_200,w_200/CORPORATIVO/2013/METRO RIO/1mtr_diret',
    className: 'proj-corp',
    category: 'Corporativo',
    priority: 1.5,
    images: [
      {
        src: baseSrc + 'CORPORATIVO/2013/METRO RIO/1mtr_diret',
        w: 1600,
        h: 1000,
      },
      {
        src: baseSrc + 'CORPORATIVO/2013/METRO RIO/2mtr_diret',
        w: 1600,
        h: 1000,
      },
      {
        src: baseSrc + 'CORPORATIVO/2013/METRO RIO/3mtr_diret',
        w: 1600,
        h: 1000,
      },
      {
        src: baseSrc + 'CORPORATIVO/2013/METRO RIO/4mtr_diret',
        w: 1600,
        h: 1000,
      },
      {
        src: baseSrc + 'CORPORATIVO/2013/METRO RIO/5mtr_diret',
        w: 1600,
        h: 1000,
      },
      {
        src: baseSrc + 'CORPORATIVO/2013/METRO RIO/6mtr_diret',
        w: 1600,
        h: 1000,
      },
      {
        src: baseSrc + 'CORPORATIVO/2013/METRO RIO/7mtr_diret',
        w: 1600,
        h: 1000,
      },
      {
        src: baseSrc + 'CORPORATIVO/2013/METRO RIO/8mtr_diret',
        w: 1600,
        h: 1000,
      },
    ],
  },
  'trp-corp': {
    name: 'Transpetro',
    year: 2013,
    src:
      baseSrc + 'c_fill,h_200,w_200/PROJETOS/CORPORATIVO/2013/TRANSPETRO/1trp',
    className: 'proj-corp',
    category: 'Corporativo',
    priority: 1.7,
    images: [
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2013/TRANSPETRO/1trp',
        w: 2028,
        h: 1028,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2013/TRANSPETRO/2trp',
        w: 2028,
        h: 1028,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2013/TRANSPETRO/3trp',
        w: 2592,
        h: 1944,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2013/TRANSPETRO/4trp',
        w: 1920,
        h: 2560,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2013/TRANSPETRO/5trp',
        w: 2560,
        h: 1920,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2013/TRANSPETRO/6trp',
        w: 1920,
        h: 2560,
      },
    ],
  },
  'lms-corp': {
    name: 'Lamsa',
    year: 2015,
    src: baseSrc + 'c_fill,h_200,w_200/PROJETOS/CORPORATIVO/2015/1rtf_lms',
    className: 'proj-corp',
    category: 'Corporativo',
    priority: 1.6,
    images: [
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2015/1rtf_lms',
        w: 4288,
        h: 2848,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2015/2rtf_lms',
        w: 3264,
        h: 2848,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2015/3rtf_lms',
        w: 4289,
        h: 2848,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2015/4rtf_lms',
        w: 2154,
        h: 2692,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2015/5rtf_lms',
        w: 2048,
        h: 1349,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2015/6rtf_lms',
        w: 3264,
        h: 1836,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2015/7rtf_lms',
        w: 3264,
        h: 2448,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2015/8rtf_lms',
        w: 3264,
        h: 2180,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2015/9rtf_lms',
        w: 3264,
        h: 2160,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2015/10rtf_lms',
        w: 3264,
        h: 2174,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2015/11rtf_lms',
        w: 2048,
        h: 1355,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2015/12rtf_lms',
        w: 3264,
        h: 2448,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2015/13rtf_lms',
        w: 1308,
        h: 1810,
      },
      {
        src: baseSrc + 'PROJETOS/CORPORATIVO/2015/14rtf_lms',
        w: 1848,
        h: 1335,
      },
    ],
  },
  'alu-ind': {
    name: 'Laboratório Alunorte',
    year: 2007,
    src: baseSrc + 'c_fill,h_200,w_200/PROJETOS/INDUSTRIAL/2007/1lab_alu',
    className: 'proj-ind',
    category: 'Industrial',
    priority: 1.9,
    images: [
      {
        src: baseSrc + 'PROJETOS/INDUSTRIAL/2007/1lab_alu',
        w: 2048,
        h: 1536,
      },
      {
        src: baseSrc + 'PROJETOS/INDUSTRIAL/2007/2lab_alu',
        w: 2048,
        h: 1536,
      },
      {
        src: baseSrc + 'PROJETOS/INDUSTRIAL/2007/3lab_alu',
        w: 2048,
        h: 1536,
      },
    ],
  },
  'afb-ind': {
    name: 'Anglo Ferrous',
    year: 2008,
    src: baseSrc + 'c_fill,h_200,w_200/PROJETOS/INDUSTRIAL/2008/ANGLO_MG/1afb',
    className: 'proj-ind',
    category: 'Industrial',
    priority: 3.4,
    images: [
      {
        src: baseSrc + 'PROJETOS/INDUSTRIAL/2008/ANGLO_MG/1afb',
        w: 1600,
        h: 1280,
      },
      {
        src: baseSrc + 'PROJETOS/INDUSTRIAL/2008/ANGLO_MG/2afb',
        w: 1600,
        h: 1280,
      },
    ],
  },
  'itab-ind': {
    name: 'Itabira',
    year: 2008,
    src: baseSrc + 'c_fill,h_200,w_200/PROJETOS/INDUSTRIAL/2008/VALE_MG/1itab',
    className: 'proj-ind',
    category: 'Industrial',
    priority: 3.5,
    images: [
      {
        src: baseSrc + 'PROJETOS/INDUSTRIAL/2008/VALE_MG/1itab',
        w: 4467,
        h: 1813,
      },
      {
        src: baseSrc + 'PROJETOS/INDUSTRIAL/2008/VALE_MG/2itab',
        w: 5093,
        h: 3184,
      },
      {
        src: baseSrc + 'PROJETOS/INDUSTRIAL/2008/VALE_MG/3itab',
        w: 3758,
        h: 1257,
      },
      {
        src: baseSrc + 'PROJETOS/INDUSTRIAL/2008/VALE_MG/4itab',
        w: 4376,
        h: 1593,
      },
      {
        src: baseSrc + 'PROJETOS/INDUSTRIAL/2008/VALE_MG/5itab',
        w: 1600,
        h: 1280,
      },
    ],
  },
  'cap-ind': {
    name: 'COMPANHIA DE ALUMINA DO PARÁ',
    year: 2010,
    src: baseSrc + 'c_fill,h_200,w_200/PROJETOS/INDUSTRIAL/2010/1cap',
    className: 'proj-ind',
    category: 'Industrial',
    priority: 2.9,
    images: [
      {
        src: baseSrc + 'PROJETOS/INDUSTRIAL/2010/1cap',
        w: 1015,
        h: 452,
      },
      {
        src: baseSrc + 'PROJETOS/INDUSTRIAL/2010/2cap',
        w: 2014,
        h: 1047,
      },
      {
        src: baseSrc + 'PROJETOS/INDUSTRIAL/2010/3cap',
        w: 2014,
        h: 1047,
      },
      {
        src: baseSrc + 'PROJETOS/INDUSTRIAL/2010/4cap',
        w: 1015,
        h: 452,
      },
      {
        src: baseSrc + 'PROJETOS/INDUSTRIAL/2010/5cap',
        w: 3300,
        h: 2550,
      },
      {
        src: baseSrc + 'PROJETOS/INDUSTRIAL/2010/6cap',
        w: 3300,
        h: 2550,
      },
    ],
  },
  'almx-ind': {
    name: 'ALMOXARIFADO CENTRAL',
    year: 2012,
    src: baseSrc + 'c_fill,h_200,w_200/PROJETOS/INDUSTRIAL/2012/1mtr_almx',
    className: 'proj-ind',
    category: 'Industrial',
    priority: 2.8,
    images: [
      {
        src: baseSrc + 'PROJETOS/INDUSTRIAL/2012/1mtr_almx',
        w: 2560,
        h: 1920,
      },
      {
        src: baseSrc + 'PROJETOS/INDUSTRIAL/2012/2_mtr_almx',
        w: 2560,
        h: 1920,
      },
      {
        src: baseSrc + 'PROJETOS/INDUSTRIAL/2012/3mtr_almx',
        w: 2560,
        h: 1920,
      },
      {
        src: baseSrc + 'PROJETOS/INDUSTRIAL/2012/4mtr_almx',
        w: 1920,
        h: 2560,
      },
      {
        src: baseSrc + 'PROJETOS/INDUSTRIAL/2012/5mtr_almx',
        w: 2936,
        h: 1084,
      },
      {
        src: baseSrc + 'PROJETOS/INDUSTRIAL/2012/6mtr_almx',
        w: 2792,
        h: 1660,
      },
      {
        src: baseSrc + 'PROJETOS/INDUSTRIAL/2012/7mtr_almx',
        w: 2560,
        h: 1920,
      },
      {
        src: baseSrc + 'PROJETOS/INDUSTRIAL/2012/8mtr_almx',
        w: 1920,
        h: 2560,
      },
      {
        src: baseSrc + 'PROJETOS/INDUSTRIAL/2012/9mtr_almx',
        w: 1920,
        h: 2560,
      },
    ],
  },
  'mmx-ind': {
    name: 'PORTO SUDESTE',
    year: 2014,
    src: baseSrc + 'c_fill,h_200,w_200/PROJETOS/INDUSTRIAL/2014/1psu_mmx',
    className: 'proj-ind',
    category: 'Industrial',
    priority: 1.8,
    images: [
      {
        src: baseSrc + 'PROJETOS/INDUSTRIAL/2014/1psu_mmx',
        w: 2187,
        h: 1652,
      },
      {
        src: baseSrc + 'PROJETOS/INDUSTRIAL/2014/4psu_mmx',
        w: 2560,
        h: 1920,
      },
      {
        src: baseSrc + 'PROJETOS/INDUSTRIAL/2014/6psu_mmx',
        w: 2560,
        h: 1920,
      },
      {
        src: baseSrc + 'PROJETOS/INDUSTRIAL/2014/7psu_mmx',
        w: 2560,
        h: 1920,
      },
      {
        src: baseSrc + 'PROJETOS/INDUSTRIAL/2014/8psu_mmx',
        w: 2560,
        h: 1920,
      },
      {
        src: baseSrc + 'PROJETOS/INDUSTRIAL/2014/9psu_mmx',
        w: 2560,
        h: 1920,
      },
    ],
  },
  'prov-esp': {
    name: 'INSTALAÇÕES PROVISÓRIAS',
    year: 2007,
    src: baseSrc + 'c_fill,h_200,w_200/PROJETOS/ESPECIAIS/2007-2008/0001',
    className: 'proj-esp',
    category: 'Especial',
    priority: 3.6,
    images: [
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2007-2008/0001',
        w: 4963,
        h: 3509,
      },
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2007-2008/0002',
        w: 4963,
        h: 3509,
      },
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2007-2008/0003',
        w: 2279,
        h: 1420,
      },
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2007-2008/0004',
        w: 683,
        h: 512,
      },
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2007-2008/0005',
        w: 763,
        h: 571,
      },
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2007-2008/0006',
        w: 2048,
        h: 1536,
      },
    ],
  },
  'mta-esp': {
    name: 'ACESSIBILIDADE ESTAÇÕES',
    year: 2010,
    src: baseSrc + 'c_fill,h_200,w_200/PROJETOS/ESPECIAIS/2010/1mtr_acess',
    className: 'proj-esp',
    category: 'Especial',
    priority: 1.92,
    images: [
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2010/1mtr_acess',
        w: 2560,
        h: 1920,
      },
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2010/2mtr_acess',
        w: 1920,
        h: 2560,
      },
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2010/3mtr_acess',
        w: 2048,
        h: 2836,
      },
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2010/4mtr_acess',
        w: 2048,
        h: 2836,
      },
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2010/7mtr_acess',
        w: 1920,
        h: 2560,
      },
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2010/8mtr_acess',
        w: 864,
        h: 477,
      },
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2010/9mtr_acess',
        w: 1087,
        h: 725,
      },
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2010/10mtr_acess',
        w: 1087,
        h: 725,
      },
    ],
  },
  'puc-est': {
    name: 'CENTRO POLIESPORTIVO',
    year: 2011,
    src: baseSrc + 'c_fill,h_200,w_200/PROJETOS/ESTUDOS/2011/1puc',
    className: 'proj-est',
    category: 'Estudo',
    priority: 99,
    images: [
      {
        src: baseSrc + 'PROJETOS/ESTUDOS/2011/1puc',
        w: 1148,
        h: 706,
      },
      {
        src: baseSrc + 'PROJETOS/ESTUDOS/2011/2puc',
        w: 1103,
        h: 757,
      },
      {
        src: baseSrc + 'PROJETOS/ESTUDOS/2011/3puc',
        w: 1296,
        h: 354,
      },
      {
        src: baseSrc + 'PROJETOS/ESTUDOS/2011/4puc',
        w: 1150,
        h: 612,
      },
    ],
  },
  'spv-esp': {
    name: 'SIMULADOR SUPERVIA',
    year: 2013,
    src: baseSrc + 'c_fill,h_200,w_200/PROJETOS/ESPECIAIS/2013/00spv_sim',
    className: 'proj-esp',
    category: 'Especial',
    priority: 2.91,
    images: [
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2013/00spv_sim',
        w: 2560,
        h: 1920,
      },
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2013/1spv_sim',
        w: 2560,
        h: 1920,
      },
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2013/2spv_sim',
        w: 2560,
        h: 1920,
      },
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2013/3spv_sim',
        w: 1920,
        h: 2560,
      },
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2013/4spv_sim',
        w: 1920,
        h: 2560,
      },
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2013/5spv_sim',
        w: 1920,
        h: 2560,
      },
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2013/6spv_sim',
        w: 2560,
        h: 1920,
      },
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2013/7spv_sim',
        w: 1920,
        h: 2560,
      },
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2013/8spv_sim',
        w: 1920,
        h: 2560,
      },
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2013/9spv_sim',
        w: 1920,
        h: 2560,
      },
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2013/11spv_sim',
        w: 1920,
        h: 2560,
      },
    ],
  },
  'mtp-esp': {
    name: 'PORTARIAS - METRÔ RIO',
    year: 2014,
    src: baseSrc + 'c_fill,h_200,w_200/PROJETOS/ESPECIAIS/2014/1mtr_prt',
    className: 'proj-esp',
    category: 'Especial',
    priority: 2.92,
    images: [
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2014/1mtr_prt',
        w: 1280,
        h: 960,
      },
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2014/2mtr_prt',
        w: 1200,
        h: 800,
      },
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2014/3mtr_prt',
        w: 1028,
        h: 736,
      },
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2014/4mtr_prt',
        w: 2145,
        h: 1512,
      },
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2014/5mtr_prt',
        w: 1896,
        h: 1428,
      },
    ],
  },
  'lms-esp': {
    name: 'REFEITÓRIO E VESTIÁRIOS LAMSA',
    year: 2015,
    src: baseSrc + 'c_fill,h_200,w_200/PROJETOS/ESPECIAIS/2015/1lms_subs',
    className: 'proj-esp',
    category: 'Especial',
    priority: 1.91,
    images: [
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2015/1lms_subs',
        w: 2540,
        h: 1834,
      },
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2015/2lms_subs',
        w: 3262,
        h: 2356,
      },
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2015/3lms_subs',
        w: 2536,
        h: 1832,
      },
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2015/4lms_subs',
        w: 2540,
        h: 1834,
      },
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2015/5lms_subs',
        w: 2540,
        h: 1834,
      },
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2015/6lms_subs',
        w: 2540,
        h: 1834,
      },
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2015/7lms_subs',
        w: 2540,
        h: 1834,
      },
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2015/8lms_subs',
        w: 4232,
        h: 3056,
      },
      {
        src: baseSrc + 'PROJETOS/ESPECIAIS/2015/9lms_subs',
        w: 2960,
        h: 4098,
      },
    ],
  },
  'cet-est': {
    name: 'CET SÃO PAULO',
    year: 2007,
    src: baseSrc + 'c_fill,h_200,w_200/PROJETOS/ESTUDOS/2007/1cet',
    className: 'proj-est',
    category: 'Estudo',
    priority: 99,
    images: [
      {
        src: baseSrc + 'PROJETOS/ESTUDOS/2007/1cet',
        w: 1200,
        h: 900,
      },
      {
        src: baseSrc + 'PROJETOS/ESTUDOS/2007/2cet',
        w: 1200,
        h: 900,
      },
      {
        src: baseSrc + 'PROJETOS/ESTUDOS/2007/3cet',
        w: 1200,
        h: 900,
      },
    ],
  },
  'bmf-est': {
    name: 'BM&F BOVESPA',
    year: 2009,
    src: baseSrc + 'c_fill,h_200,w_200/PROJETOS/ESTUDOS/2009/1bmf',
    className: 'proj-est',
    category: 'Estudo',
    priority: 99,
    images: [
      {
        src: baseSrc + 'PROJETOS/ESTUDOS/2009/1bmf',
        w: 1000,
        h: 667,
      },
      {
        src: baseSrc + 'PROJETOS/ESTUDOS/2009/2bmf',
        w: 1000,
        h: 667,
      },
      {
        src: baseSrc + 'PROJETOS/ESTUDOS/2009/3bmf',
        w: 1000,
        h: 667,
      },
      {
        src: baseSrc + 'PROJETOS/ESTUDOS/2009/4bmf',
        w: 971,
        h: 591,
      },
      {
        src: baseSrc + 'PROJETOS/ESTUDOS/2009/5bmf',
        w: 5748,
        h: 5928,
      },
      {
        src: baseSrc + 'PROJETOS/ESTUDOS/2009/6bmf',
        w: 1158,
        h: 1261,
      },
    ],
  },
  'odia-est': {
    name: 'JORNAL O DIA',
    year: 2013,
    src: baseSrc + 'c_fill,h_200,w_200/PROJETOS/ESTUDOS/2013/1odia',
    className: 'proj-est',
    category: 'Estudo',
    priority: 99,
    images: [
      {
        src: baseSrc + 'PROJETOS/ESTUDOS/2013/1odia',
        w: 1024,
        h: 768,
      },
    ],
  },
}

export const projectFilters = [
  {
    filter: '*',
    name: 'Todos',
  },
  {
    filter: '.proj-cco',
    name: 'Centro de Controle Operacional',
  },
  {
    filter: '.proj-corp',
    name: 'Corporativo',
  },
  {
    filter: '.proj-ind',
    name: 'Industrial',
  },
  {
    filter: '.proj-esp',
    name: 'Especial',
  },
  {
    filter: '.proj-est',
    name: 'Estudo',
  },
]
